// Landing page for the magic link: exchanges the token for a session, then continues.
import { useEffect, useRef, useState } from "react";
import { api, ApiError } from "../lib/api";
import { Link, navigate, useLocation } from "../lib/router";
import { useSession } from "../lib/session";

export default function Verify() {
  const { search } = useLocation();
  const { refresh } = useSession();
  const [error, setError] = useState("");
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke would burn the single-use token
    ran.current = true;
    const token = search.get("token");
    const next = search.get("next");
    if (!token) return setError("This link is missing its sign-in token.");
    api
      .verify({ token })
      .then(async () => {
        await refresh();
        navigate(next && /^\/[^/]/.test(next) ? next : "/", { replace: true });
      })
      .catch((e: ApiError) => setError(e.message));
  }, [search, refresh]);
  return (
    <div className="page narrow">
      {error ? (
        <>
          <h1>That link didn't work</h1>
          <p>{error}</p>
          <Link className="btn btn-primary" to="/signin">Send a new link</Link>
        </>
      ) : (
        <p className="muted">Signing you in…</p>
      )}
    </div>
  );
}
